import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import RenderDays from './RenderDays';
import RenderDaysHeader from './RenderDaysHeader';
import RenderWeeks from './RenderWeeks';
import { Box } from '@material-ui/core';
import { DateRangeContext } from '../Preview/Preview.context';
import styles from './Layout.style';

moment.updateLocale('wm', {
	week: {
		dow: 6
	}
});

moment.updateLocale('std', {
	week: {
		dow: 0
	}
});

function Layout({ month, min, max, minWk, maxWk }) {
	const { cbSetDateRange, usrSelection, showWk, showWalCal, singleWkSelEnable, updateDateFor } =
		useContext(DateRangeContext);
	const [calSelection, setCalSelection] = useState({ ...usrSelection });
	const classes = styles();
	const { calContainer, calander, days } = classes;

	useEffect(() => {
		setCalSelection({ ...usrSelection });
	}, [usrSelection]);

	function handleWeekDayHighlight(selWeek, wk = 1) {
		const duration = showWk ? 'week' : 'day';
		let _selection = {};

		/** initial launch of calendar when no prior selection done || if START textfield selected. */
		if (
			[calSelection.start, calSelection.end].includes(undefined) ||
			(updateDateFor === 'START' && selWeek.isSameOrAfter(calSelection.end))
		) {
			_selection = {
				week1: wk,
				week2: wk,
				start: moment(selWeek).startOf(duration),
				end: moment(selWeek).endOf(duration)
			};
		}

		/** if user click on already selected dates or earlier dates */
		if (calSelection.start && selWeek.isSameOrBefore(calSelection.start)) {
			_selection = {
				...calSelection,
				week1: wk,
				start: moment(selWeek).startOf(duration)
			};
		}

		if (
			calSelection.end &&
			selWeek.isBefore(calSelection.end) &&
			selWeek.isAfter(calSelection.start)
		) {
			if (updateDateFor === 'START') {
				_selection = {
					...calSelection,
					week1: wk,
					start: moment(selWeek).startOf(duration)
				};
			} else {
				_selection = {
					...calSelection,
					week2: wk,
					end: moment(selWeek).endOf(duration)
				};
			}
		}

		/** if user click on already selected dates or later dates */
		if (updateDateFor !== 'START' && calSelection.end && selWeek.isSameOrAfter(calSelection.end)) {
			_selection = {
				...calSelection,
				week2: wk,
				end: moment(selWeek).endOf(duration)
			};
		}

		setCalSelection(_selection);
		cbSetDateRange(_selection);
	}

	function handleSingleWeekDayHighligh(selWeek, wk = 1) {
		const duration = showWk ? 'week' : 'day';
		let _selection = {};
		_selection = {
			week1: wk,
			week2: wk,
			start: moment(selWeek).startOf(duration),
			end: moment(selWeek).endOf(duration)
		};

		setCalSelection(_selection);
		cbSetDateRange(_selection);
	}

	const commonProps = {
		calSelection: calSelection,
		showWkSelection: showWk,
		min: min,
		max: max,
		minWk: minWk,
		maxWk: maxWk
	};

	return (
		<Box className={calContainer}>
			{month.map((_m) => {
				return (
					<Box className={calander} key={_m}>
						<Box style={{ display: 'flex' }}>
							<RenderWeeks
								cbWeekHighlight={
									singleWkSelEnable ? handleSingleWeekDayHighligh : handleWeekDayHighlight
								}
								showWalCal={showWalCal}
								_month={_m}
								{...commonProps}
							/>
							<Box className={days}>
								<RenderDaysHeader showWalCal={showWalCal} />
								<RenderDays
									_month={_m}
									cbDaySelection={
										singleWkSelEnable ? handleSingleWeekDayHighligh : handleWeekDayHighlight
									}
									{...commonProps}
								/>
							</Box>
						</Box>
					</Box>
				);
			})}
		</Box>
	);
}

export default Layout;
